<script setup>
import DOMPurify from 'dompurify'
import { marked } from 'marked'

const props = defineProps({
  source: { default: '', type: String },
})

const compiledMarkdown = computed(() =>
  DOMPurify.sanitize(marked(props.source, { breaks: true })),
)
</script>

<template>
  <div v-html="compiledMarkdown" />
</template>
